export const settingsFormFields = {
  company_id: {
    label: 'ID empresa',
    type: 'text',
  },
  app: {
    label: 'App',
    type: 'text',
  },
  url: {
    label: 'URL',
    type: 'text',
  },
  username: {
    label: 'Usuario',
    type: 'email',
  },
  password: {
    label: 'Contraseña',
    type: 'password',
  },
  api_key: {
    label: 'Clave API',
    type: 'text',
  },
  token: {
    label: 'Token',
    type: 'text',
  },
  customer_id: {
    label: 'ID cliente',
    type: 'text',
  },
  accepted_warehouses: {
    label: 'Ubicaciones para productos aceptados',
    type: 'text',
    helperText: 'Añade múltiples ubicaciones separadas por comas (,)',
  },
  site_id: {
    label: 'ID sitio',
    type: 'text',
  },
  domain: {
    label: 'Dominio',
    type: 'text',
  },
  partner_hash: {
    label: 'Partner Hash',
    type: 'text',
  },
  client_id: {
    label: 'ID de cliente',
    type: 'text',
  },
  owner_id: {
    label: 'ID de propietario',
    type: 'text',
  },
  config_id: {
    label: 'ID de configuración',
    type: 'text',
  },
  client_group: {
    label: 'Grupo de cliente',
    type: 'text',
  },
  pallet_config: {
    label: 'Configuración de palet',
    type: 'text',
  },
  accepted_states: {
    label: 'Estados para productos aceptados',
    type: 'text',
    helperText: 'Añade múltiples estados separados por comas (,)',
  },
  rejected_states: {
    label: 'Estados para productos rechazados',
    type: 'text',
    helperText: 'Añade múltiples estados separados por comas (,)',
  },
  profile: {
    label: 'Perfil',
    type: 'text',
  },
  account: {
    label: 'Nombre de la cuenta',
    type: 'text',
    helperText:
      'Si la dirección de tu cuenta de Gorgias es por ejemplo https://miempresa.gorgias.com, el nombre de la cuenta que tienes que introducir aquí es "miempresa"',
  },
  webhook_secret: {
    label: 'Clave de firma de webhook',
    type: 'text',
    optional: true,
    helperText:
      'Introduce la clave de firma de webhooks de tu cuenta de Primer para que Reveni pueda validar el origen de las notificaciones de pago.',
  },
  client_secret: {
    label: 'Secreto de cliente',
    type: 'text',
  },
  warehouse: {
    label: 'Almacén',
    type: 'text',
  },
  ship_to_codes: {
    label: 'Códigos de envío',
    type: 'text',
    helperText: 'Añade múltiples códigos separados por comas (,)',
  },
  account_id: {
    label: 'ID de cuenta',
    type: 'text',
  },
  location_id: {
    label: 'ID de ubicación',
    type: 'text',
  },
  stock_pool: {
    label: 'Pool de stock',
    type: 'text',
  },
  ilg_class: {
    label: 'Clase ILG',
    type: 'text',
  },
  brand: {
    label: 'Marca',
    type: 'text',
  },
  app_id: {
    label: 'ID de aplicación',
    type: 'text',
  },
  app_secret: {
    label: 'Secreto de aplicación',
    type: 'text',
  },
  install_token: {
    label: 'Token de instalación',
    type: 'text',
  },
}
